import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { PopupEvent } from 'webapp/enums/enums';

import AccountPopupPartnerComponent from 'webapp/components/account/popup-partner';

export default class PartnerLevelRoute extends Route {
	@service('popup') declare popupService: Service.Popup;
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('infolayer') declare infolayerService: Service.Infolayer;

	override beforeModel(transition: PublicTransition): void {
		if (this.accountService.isAgency) {
			return;
		}

		if (!transition.sequence) {
			this.navigationService.replaceRoute('index');
		} else {
			transition.abort();
		}

		this.infolayerService.error('Only available in multi-account organizations');
	}

	override afterModel(): void {
		const popup = this.popupService.createModal(AccountPopupPartnerComponent);
		popup.open(); // <void>
		popup.on(PopupEvent.CLOSING, this, () => {
			this.navigationService.transitionToRoute('settings.level');
		});
	}
}
